import { Label, Panel } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { Model, Navigation } from "@mcleod/core";

/**
 * Class for validating Bonus Tax Rate dependencies before save.
 * Usage: await BonusTaxUtils.checkBonusTaxRates(activeRow)
 */
export class BonusTaxUtils {
    static async checkBonusTaxRates(activeRow: any): Promise<boolean> {
        const bonusTaxMethod = activeRow.get("bonus_tax_method");
        if (bonusTaxMethod !== "B") {
            return true;
        }
        let isValid = true;
        const panel = new Panel();
        const infoText = new Label({
            fontBold: true,
            text: "The Bonus Tax Rate is not set for the following tax tables, please update before saving this record:"
        });
        panel.add(infoText);

        const fedTaxTable = await Model.searchSingleRecord("lme/settlement/fedtaxtable");
        if (fedTaxTable == null || fedTaxTable.isNull("bonus_tax_rate")) {
            const fedTaxLabel = new Label({ text: "Update Federal Tax Table" });
            fedTaxLabel.applyLinkStyle();
            fedTaxLabel.addClickListener(() => {
                Navigation.navigateTo("lme/settlement/FederalTaxTable", { newTab: true });
            });
            panel.add(new Label({ text: "• ", rowBreak: false }));
            panel.add(fedTaxLabel);
            isValid = false;
        }

        const stateLocalTaxTables = await Model.search("lme/ar/statetax", { type_of: "S" });
        const stateLocalTaxTableIds: string[] = [];
        for (const taxTable of stateLocalTaxTables.modelRows) {
            if (taxTable.isNull("bonus_tax_rate")) {
                stateLocalTaxTableIds.push(taxTable.get("id"));
            }
        }
        if (stateLocalTaxTableIds.length > 0) {
            const stateTaxLabel = new Label({ text: "Update State Tax Tables" });
            stateTaxLabel.applyLinkStyle();
            stateTaxLabel.addClickListener(() => {
                Navigation.navigateTo("lme/settlement/StateTaxTableList?ids=" + encodeURIComponent(stateLocalTaxTableIds.join(",")), { newTab: true });
            });
            panel.add(new Label({ text: "• ", rowBreak: false }));
            panel.add(stateTaxLabel);
            isValid = false;
        }

        if (!isValid) {
            CommonDialogs.showDialog(panel, { title: "Error", width: 350 });
        }

        return isValid;
    }
}
